import { present } from 'shared/presenters/presenter'
import { Disclaimers_Parties } from 'shared/presenters/graphqlTypes'

export class DisclaimerPartyPresenter extends present<Disclaimers_Parties>() {
  isDisclaimerAgreed = () => {
    return this.disclaimer?.agreed ?? false
  }
}
